import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../components/Login/Login";
import LayoutMain from "../components/Layout";
import { GetToken } from "../components/utils";

import Home from "../components/Home";
import City from "../components/City";
import Slider from "../components/Slider";
import Area from "../components/Area";
import Occasion from "../components/Occasion";
import OccasionFunctions from "../components/OccasionFunctions";
import FunctionEssentials from "../components/FunctionEssentials";
import EssentialTypes from "../components/EssentialTypes";
import Orders from "../components/Orders";
import OrderDetails from "../components/OrderDetails/OrderDetails.jsx";
import Venues from "../pages/Venues.jsx";
import Gallery from "../components/gallery";
import YouTube from "../components/youtube";
import Users from "../components/Users";
import Bookings from "../components/OrderDetails/Bookings";


function PageRouter() {
  function RequireAuth({ children }) {
    const token = GetToken();
    return token ? children : <Navigate to="/login" replace />;
  }
  function AlreadyLogin({ children }) {
    const token = GetToken();
    return token ? <Navigate to="/" replace /> : children;
  }
  return (
    <div>
      <Routes>
        <Route
          path="/login"
          element={
            <AlreadyLogin>
              <Login />
            </AlreadyLogin>
          }
        />
        <Route
          element={
            <RequireAuth>
              {" "}
              <LayoutMain />
            </RequireAuth>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/city" element={<City />} />
          <Route path="/area" element={<Area />} />
          <Route path="/slider" element={<Slider />} />
          <Route path="/occasion" element={<Occasion />} />
          <Route path="/occasion-functions" element={<OccasionFunctions />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/function-essentials" element={<FunctionEssentials />} />
          <Route path="/essential-types" element={<EssentialTypes />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetails />} />
          <Route path="/orders/:orderId/functions/:functionId/bookings" element={<Bookings />}/>
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/youtube" element={<YouTube />} />
          <Route path="/users" element={<Users />} />
        </Route>
      </Routes>
    </div>
  );
};

export default PageRouter;
